export default __webpack_public_path__ + "static/media/RB_PotPro.93275a86.jpg";